import { render, staticRenderFns } from "./rotateTips.vue?vue&type=template&id=c0dc2250&scoped=true"
import script from "./rotateTips.vue?vue&type=script&lang=js"
export * from "./rotateTips.vue?vue&type=script&lang=js"
import style0 from "./rotateTips.vue?vue&type=style&index=0&id=c0dc2250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dc2250",
  null
  
)

export default component.exports